module.exports = __webpack_public_path__ + "img/chongzhou4.b9fc89ed.png";